import React, { useState, useEffect } from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import { ManageTemplateDialogBase } from './ManageTemplate';

interface ManageTemplateDialogProps extends ManageTemplateDialogBase {
    children?: React.ReactNode;
    dialogOpenState: boolean;
    openDialog?: () => void;
    closeDialog: () => void;
    title: string;
    submitBtnText: string;
    submitBtnColorType: any;
    submitBtnDisabled?: boolean;
    cancelBtnText?: string;
    cancelBtnColorType?: any;
}

const ManageTemplateDialog: React.FC<ManageTemplateDialogProps> = (props) => {
    const [busy, setBusy] = useState(false);
    const {
        dialogMessage,
        dialogOpenState,
        closeDialog,
        onDelete = () => {},
    } = props;

    useEffect(() => {
        if (dialogOpenState) {
            setBusy(false);
        }
    }, [dialogOpenState]);

    return (
        <Dialog
            id={'confirmation-dialog'}
            maxWidth="sm"
            fullWidth
            open={dialogOpenState}
            onClose={closeDialog}
        >
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                {dialogMessage && (
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        {dialogMessage}
                    </Typography>
                )}
                {props.children}
            </DialogContent>
            <DialogActions>
                <Button
                    id="confirmation-dialog-cancel-button"
                    variant="outlined"
                    color="secondary"
                    onClick={closeDialog}
                >
                    {props.cancelBtnText ? props.cancelBtnText : 'Cancel'}
                </Button>
                <Button
                    id="confirmation-dialog-submit-button"
                    disabled={props.submitBtnDisabled}
                    color={
                        props.submitBtnColorType === 'error'
                            ? 'error'
                            : 'primary'
                    }
                    variant="contained"
                    startIcon={
                        busy ? (
                            <CircularProgress size={16} color="inherit" />
                        ) : undefined
                    }
                    onClick={(): void => {
                        setBusy(true);
                        closeDialog();
                        onDelete();
                    }}
                >
                    {props.submitBtnText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ManageTemplateDialog;
